<template>
  <div class="jss-loading" v-if="visible"></div>
</template>

<script>
export default {
  data() {
    return {
      visible: false
    };
  },
  props: {
    delay: {
      type: Number,
      default: 500
    }
  },
  created() {
    // Wait {this.delay}ms before making the loading graphic visible.
    // If whatever other async operation completes within that timeframe,
    // then whichever parent component invoked the loading component will
    // presumably re-render without the loading component.
    // This helps prevent the loading graphic from too briefly "flashing" on the screen
    // causing an undesirable flicker for users.
    setTimeout(() => {
      this.visible = true;
    }, this.delay);
  }
};
</script>
